import React from "react";
import { ReceiptText, ArrowRight } from "lucide-react";

const Expenses = () => {
  return (
    <div className="bg-white h-full flex flex-col">
      {/* Header Section */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-[#E5E7EB]">
        <h1 className="text-2xl font-semibold font-outfit text-[#374151]">
          Expense Management
        </h1>
      </div>

      {/* Coming Soon Content */}
      <div className="flex flex-col p-6 max-w-7xl mx-auto w-full">
        <div className="flex mb-8 border-b border-[#E5E7EB] pb-6">
          <div className="w-16 h-16 bg-[#F3F2FF] rounded-full flex items-center justify-center mr-6 flex-shrink-0">
            <ReceiptText size={32} className="text-[#5652B0]" />
          </div>
          <div className="flex flex-col items-start text-left">
            <h2 className="text-2xl font-bold text-[#374151] mb-3 text-left">
              Coming Soon
            </h2>
            <p className="text-[#4B5563] text-base leading-relaxed text-left">
              We're building a comprehensive Expense Management system to help
              you track, categorize and monitor all your business expenses for
              better financial control and planning.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-b from-[#FFFFFF] to-[#F9FAFB] border border-[#E5E7EB] rounded-xl p-6 w-full shadow-sm">
          <h3 className="text-xl font-semibold text-[#374151] mb-4 border-b border-[#EFF1F5] pb-2">
            This module will include:
          </h3>

          <div className="grid grid-cols-3 gap-4">
            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Expense Tracking
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Record and categorize all business expenses with receipt
                  uploads and detailed descriptions.
                </p>
              </div>
            </div>

            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Expense Categories
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Organize expenses into customizable categories for better
                  financial analysis and tax reporting.
                </p>
              </div>
            </div>

            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Recurring Expenses
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Set up and manage recurring expenses such as rent, utilities,
                  and subscriptions.
                </p>
              </div>
            </div>

            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Expense Analytics
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Generate detailed reports and visualizations to analyze
                  spending patterns and identify cost-saving opportunities.
                </p>
              </div>
            </div>

            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Budget Planning
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Create and manage expense budgets by category and track actual
                  spending against planned amounts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expenses;
